var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditorChoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 46,
    viewBox: "0 0 42 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99999 45.833V28.0122L0.958328 16.583L10.9792 0.333008H31.0208L41.0417 16.583L34 28.0122V45.833L21 41.4997L7.99999 45.833ZM12.3333 39.8205L21 36.9497L29.6667 39.8205V32.833H12.3333V39.8205ZM13.4167 4.66634L6.04999 16.583L13.4167 28.4997H28.5833L35.95 16.583L28.5833 4.66634H13.4167ZM18.725 25.4122L11.0333 17.7747L14.1208 14.6872L18.725 19.2913L27.8792 10.083L30.9667 13.1163L18.725 25.4122Z",
    fill: "#DF6B4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditorChoice);
export default __webpack_public_path__ + "static/media/editor_choice.d1a8f8e5afadd9b6aa97470b8edc4498.svg";
export { ForwardRef as ReactComponent };